import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button'
import FormLabel  from '@material-ui/core/FormLabel';
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'axios';

const EditProfilePage = ({ 
  viewerObj, 
  setViewerObj, 
  connectedStripeId 
}) => {

  const API_URL = "https://310nwnmom8.execute-api.us-west-2.amazonaws.com";

  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // when the viewerObj is mounted load update the email state
  useEffect(() =>{ 
    if(viewerObj) setEmail(viewerObj.email)
  },[viewerObj])

  const onChange = ({ target }) => {
    // reset error and load state if theres an active error message
    if(errorMessage) { 
      setErrorMessage('');
      setIsLoading(false);
    }

    setEmail(target.value);
  }

  const submitUserDetails = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    setSuccessMessage("");
   
    // check if the new email is the same as current one
    if(email === viewerObj.email) return setErrorMessage('email cannot be the same as current email');

    const { error } = await axios.post(`${API_URL}/update-email`, 
    { 
      viewerId: viewerObj._id,
      newEmail: email,
      connectedStripeId 
    });

    console.log(error)
    
    // update the state of the viewer object with the new email
    setViewerObj({ ...viewerObj, email });

    // update the email in local storage to sustain login
    localStorage.setItem('email', email);
    
    // reset all states back to default values
    setSuccessMessage('email updated successfully')
    setTimeout(() => setSuccessMessage(''), 5000);
    setIsLoading(false);
  }

  return (
  <>
    {viewerObj && 
    <>
        {errorMessage && <Alert 
                    variant="filled" 
                    severity="error"
                    >
                      {errorMessage}
                    </Alert>}
        {successMessage && <Alert 
                          variant="filled" 
                          severity="success"
                          >
                            {successMessage}
                          </Alert>}
       <form onSubmit={submitUserDetails}>
        <FormLabel>Email</FormLabel>
        <TextField
          fullWidth  
          type='email' 
          value={email} 
          onChange={onChange}
          variant="outlined" 
          required/>
        <Button 
          type="submit"
          variant="contained"
          color="primary"
          disabled={isLoading}
        >
          Submit
        </Button>
      </form>
    </>}

      {!viewerObj && 
        <Skeleton 
          animation="wave" 
          variant="text" 
          width={890} 
          height={95} />
      }
    
  </>
  )
}

export default EditProfilePage